import { Controller } from "@hotwired/stimulus"

// Skip Late Messages on Workflow Defaults by Trigger: the amount dropdown lists
// the amounts its unit offers (Crm::Workflows::MaxSendDelay::CHOOSABLE_RANGES,
// rendered as the ranges value { unit: [min, max] } — 1–23 hours, 1–10 days).
// The server renders the saved unit's list (plus a saved value outside it);
// changing the unit rebuilds the list and keeps the amount, or the nearest one
// the new unit offers. The server still validates.
export default class extends Controller {
  static targets = ["amount", "unit"]
  static values = { ranges: Object }

  update() {
    if (!this.hasAmountTarget || !this.hasUnitTarget) return

    const range = this.rangesValue[this.unitTarget.value]
    if (!Array.isArray(range)) return

    const [min, max] = range
    const current = Number(this.amountTarget.value)
    const kept = Math.min(Math.max(Number.isFinite(current) ? current : min, min), max)

    this.amountTarget.replaceChildren()
    for (let amount = min; amount <= max; amount++) {
      this.amountTarget.add(new Option(String(amount), String(amount), false, amount === kept))
    }
    this.amountTarget.value = String(kept)
  }
}
